require("core-js/modules/es6.string.link");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.string.big");

require("core-js/modules/es6.string.sub");

require("core-js/modules/es6.string.sup");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./helix.core.js");

require("./helix.impl.props.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("helix.dom.js");
goog.provide('helix.dom');
helix.dom.tags = cljs.core.PersistentVector.fromArray([new cljs.core.Symbol(null, "input", "input", -2097503808, null), new cljs.core.Symbol(null, "textarea", "textarea", 990155703, null), new cljs.core.Symbol(null, "option", "option", 1705663799, null), new cljs.core.Symbol(null, "select", "select", -1506602266, null), new cljs.core.Symbol(null, "a", "a", -482876059, null), new cljs.core.Symbol(null, "abbr", "abbr", -565843885, null), new cljs.core.Symbol(null, "address", "address", -2094936343, null), new cljs.core.Symbol(null, "area", "area", 2112538783, null), new cljs.core.Symbol(null, "article", "article", 1618846482, null), new cljs.core.Symbol(null, "aside", "aside", -1240038232, null), new cljs.core.Symbol(null, "audio", "audio", -835308448, null), new cljs.core.Symbol(null, "b", "b", -1172211299, null), new cljs.core.Symbol(null, "base", "base", 1825810849, null), new cljs.core.Symbol(null, "bdi", "bdi", 317505641, null), new cljs.core.Symbol(null, "bdo", "bdo", -490616675, null), new cljs.core.Symbol(null, "big", "big", -1750885618, null), new cljs.core.Symbol(null, "blockquote", "blockquote", 2012795717, null), new cljs.core.Symbol(null, "body", "body", -408674142, null), new cljs.core.Symbol(null, "br", "br", -1720330977, null), new cljs.core.Symbol(null, "button", "button", -1197855826, null), new cljs.core.Symbol(null, "canvas", "canvas", -158285962, null), new cljs.core.Symbol(null, "caption", "caption", 785147625, null), new cljs.core.Symbol(null, "cite", "cite", -744995773, null), new cljs.core.Symbol(null, "code", "code", -1068142627, null), new cljs.core.Symbol(null, "col", "col", -318831557, null), new cljs.core.Symbol(null, "colgroup", "colgroup", -2003317124, null), new cljs.core.Symbol(null, "data", "data", 1407862150, null), new cljs.core.Symbol(null, "datalist", "datalist", 405488053, null), new cljs.core.Symbol(null, "dd", "dd", 300093898, null), new cljs.core.Symbol(null, "del", "del", -2079460185, null), new cljs.core.Symbol(null, "details", "details", -697640358, null), new cljs.core.Symbol(null, "dfn", "dfn", 1882439694, null), new cljs.core.Symbol(null, "dialog", "dialog", -1239285634, null), new cljs.core.Symbol(null, "div", "div", -1597244137, null), new cljs.core.Symbol(null, "dl", "dl", -499620186, null), new cljs.core.Symbol(null, "dt", "dt", 1272086768, null), new cljs.core.Symbol(null, "em", "em", -1946622734, null), new cljs.core.Symbol(null, "embed", "embed", 285618178, null), new cljs.core.Symbol(null, "fieldset", "fieldset", -309239289, null), new cljs.core.Symbol(null, "figcaption", "figcaption", -149590520, null), new cljs.core.Symbol(null, "figure", "figure", 1079137448, null), new cljs.core.Symbol(null, "footer", "footer", -1047990379, null), new cljs.core.Symbol(null, "form", "form", 16469056, null), new cljs.core.Symbol(null, "h1", "h1", -256355935, null), new cljs.core.Symbol(null, "h2", "h2", 1267868799, null), new cljs.core.Symbol(null, "h3", "h3", -586824606, null), new cljs.core.Symbol(null, "h4", "h4", -649572776, null), new cljs.core.Symbol(null, "h5", "h5", -188625098, null), new cljs.core.Symbol(null, "h6", "h6", -2097141989, null), new cljs.core.Symbol(null, "head", "head", 869147608, null), new cljs.core.Symbol(null, "header", "header", 1759972661, null), new cljs.core.Symbol(null, "hr", "hr", -1276695702, null), new cljs.core.Symbol(null, "html", "html", 641734630, null), new cljs.core.Symbol(null, "i", "i", 253690212, null), new cljs.core.Symbol(null, "iframe", "iframe", -1770013743, null), new cljs.core.Symbol(null, "img", "img", -1211748411, null), new cljs.core.Symbol(null, "ins", "ins", 618547957, null), new cljs.core.Symbol(null, "kbd", "kbd", 1956688402, null), new cljs.core.Symbol(null, "keygen", "keygen", 1068838274, null), new cljs.core.Symbol(null, "label", "label", -936024965, null), new cljs.core.Symbol(null, "legend", "legend", 613339282, null), new cljs.core.Symbol(null, "li", "li", -1930876848, null), new cljs.core.Symbol(null, "link", "link", -128631941, null), new cljs.core.Symbol(null, "main", "main", -477271134, null), new cljs.core.Symbol(null, "map", "map", -1282745308, null), new cljs.core.Symbol(null, "mark", "mark", 1266715182, null), new cljs.core.Symbol(null, "menu", "menu", 1992786725, null), new cljs.core.Symbol(null, "menuitem", "menuitem", -1650388416, null), new cljs.core.Symbol(null, "meta", "meta", -1154898805, null), new cljs.core.Symbol(null, "meter", "meter", 1452889916, null), new cljs.core.Symbol(null, "nav", "nav", -1934895292, null), new cljs.core.Symbol(null, "noscript", "noscript", 935754238, null), new cljs.core.Symbol(null, "object", "object", -1179821820, null), new cljs.core.Symbol(null, "ol", "ol", -1721911718, null), new cljs.core.Symbol(null, "optgroup", "optgroup", -916153551, null), new cljs.core.Symbol(null, "output", "output", 534662484, null), new cljs.core.Symbol(null, "p", "p", 1791580836, null), new cljs.core.Symbol(null, "param", "param", -640803946, null), new cljs.core.Symbol(null, "picture", "picture", 718588123, null), new cljs.core.Symbol(null, "pre", "pre", -535978900, null), new cljs.core.Symbol(null, "progress", "progress", 1884855074, null), new cljs.core.Symbol(null, "q", "q", -1965434072, null), new cljs.core.Symbol(null, "rp", "rp", -647737686, null), new cljs.core.Symbol(null, "rt", "rt", -2030955077, null), new cljs.core.Symbol(null, "ruby", "ruby", -653698108, null), new cljs.core.Symbol(null, "s", "s", -948495851, null), new cljs.core.Symbol(null, "samp", "samp", -1148294633, null), new cljs.core.Symbol(null, "script", "script", 336087726, null), new cljs.core.Symbol(null, "section", "section", 1340390001, null), new cljs.core.Symbol(null, "small", "small", -520957065, null), new cljs.core.Symbol(null, "source", "source", 1206599988, null), new cljs.core.Symbol(null, "span", "span", -1259562778, null), new cljs.core.Symbol(null, "strong", "strong", 1910060527, null), new cljs.core.Symbol(null, "style", "style", 1143888791, null), new cljs.core.Symbol(null, "sub", "sub", -453228498, null), new cljs.core.Symbol(null, "summary", "summary", 2021379479, null), new cljs.core.Symbol(null, "sup", "sup", -398960819, null), new cljs.core.Symbol(null, "table", "table", 1075588491, null), new cljs.core.Symbol(null, "tbody", "tbody", 1559853227, null), new cljs.core.Symbol(null, "td", "td", -1174502416, null), new cljs.core.Symbol(null, "tfoot", "tfoot", 938931637, null), new cljs.core.Symbol(null, "th", "th", 1094922961, null), new cljs.core.Symbol(null, "thead", "thead", 1348656231, null), new cljs.core.Symbol(null, "time", "time", -1268547887, null), new cljs.core.Symbol(null, "title", "title", -2017930186, null), new cljs.core.Symbol(null, "tr", "tr", 215756881, null), new cljs.core.Symbol(null, "track", "track", 1836319014, null), new cljs.core.Symbol(null, "u", "u", 483896742, null), new cljs.core.Symbol(null, "ul", "ul", 291010124, null), new cljs.core.Symbol(null, "var", "var", 870848730, null), new cljs.core.Symbol(null, "video", "video", 1797419657, null), new cljs.core.Symbol(null, "wbr", "wbr", 1869193327, null), new cljs.core.Symbol(null, "circle", "circle", -751223407, null), new cljs.core.Symbol(null, "clipPath", "clipPath", 705911730, null), new cljs.core.Symbol(null, "ellipse", "ellipse", -1518544067, null), new cljs.core.Symbol(null, "g", "g", -916345864, null), new cljs.core.Symbol(null, "line", "line", 1852876762, null), new cljs.core.Symbol(null, "mask", "mask", 1054783080, null), new cljs.core.Symbol(null, "path", "path", 1452340359, null), new cljs.core.Symbol(null, "pattern", "pattern", 1882666950, null), new cljs.core.Symbol(null, "polyline", "polyline", -91019517, null), new cljs.core.Symbol(null, "rect", "rect", 1531628899, null), new cljs.core.Symbol(null, "svg", "svg", -1797646627, null), new cljs.core.Symbol(null, "text", "text", -150030170, null), new cljs.core.Symbol(null, "defs", "defs", -1255986052, null), new cljs.core.Symbol(null, "linearGradient", "linearGradient", -942471042, null), new cljs.core.Symbol(null, "polygon", "polygon", -1817382010, null), new cljs.core.Symbol(null, "radialGradient", "radialGradient", -1252188576, null), new cljs.core.Symbol(null, "stop", "stop", -500379815, null), new cljs.core.Symbol(null, "tspan", "tspan", 82678330, null)], true);
Object.defineProperty(module.exports, "form", {
  enumerable: false,
  get: function get() {
    return helix.dom.form;
  }
});
Object.defineProperty(module.exports, "audio", {
  enumerable: false,
  get: function get() {
    return helix.dom.audio;
  }
});
Object.defineProperty(module.exports, "input", {
  enumerable: false,
  get: function get() {
    return helix.dom.input;
  }
});
Object.defineProperty(module.exports, "menuitem", {
  enumerable: false,
  get: function get() {
    return helix.dom.menuitem;
  }
});
Object.defineProperty(module.exports, "radialGradient", {
  enumerable: false,
  get: function get() {
    return helix.dom.radialGradient;
  }
});
Object.defineProperty(module.exports, "base", {
  enumerable: false,
  get: function get() {
    return helix.dom.base;
  }
});
Object.defineProperty(module.exports, "h1", {
  enumerable: false,
  get: function get() {
    return helix.dom.h1;
  }
});
Object.defineProperty(module.exports, "embed", {
  enumerable: false,
  get: function get() {
    return helix.dom.embed;
  }
});
Object.defineProperty(module.exports, "h3", {
  enumerable: false,
  get: function get() {
    return helix.dom.h3;
  }
});
Object.defineProperty(module.exports, "body", {
  enumerable: false,
  get: function get() {
    return helix.dom.body;
  }
});
Object.defineProperty(module.exports, "keygen", {
  enumerable: false,
  get: function get() {
    return helix.dom.keygen;
  }
});
Object.defineProperty(module.exports, "progress", {
  enumerable: false,
  get: function get() {
    return helix.dom.progress;
  }
});
Object.defineProperty(module.exports, "main", {
  enumerable: false,
  get: function get() {
    return helix.dom.main;
  }
});
Object.defineProperty(module.exports, "cite", {
  enumerable: false,
  get: function get() {
    return helix.dom.cite;
  }
});
Object.defineProperty(module.exports, "rect", {
  enumerable: false,
  get: function get() {
    return helix.dom.rect;
  }
});
Object.defineProperty(module.exports, "polyline", {
  enumerable: false,
  get: function get() {
    return helix.dom.polyline;
  }
});
Object.defineProperty(module.exports, "map", {
  enumerable: false,
  get: function get() {
    return helix.dom.map;
  }
});
Object.defineProperty(module.exports, "object", {
  enumerable: false,
  get: function get() {
    return helix.dom.object;
  }
});
Object.defineProperty(module.exports, "i", {
  enumerable: false,
  get: function get() {
    return helix.dom.i;
  }
});
Object.defineProperty(module.exports, "p", {
  enumerable: false,
  get: function get() {
    return helix.dom.p;
  }
});
Object.defineProperty(module.exports, "nav", {
  enumerable: false,
  get: function get() {
    return helix.dom.nav;
  }
});
Object.defineProperty(module.exports, "ruby", {
  enumerable: false,
  get: function get() {
    return helix.dom.ruby;
  }
});
Object.defineProperty(module.exports, "a", {
  enumerable: false,
  get: function get() {
    return helix.dom.a;
  }
});
Object.defineProperty(module.exports, "menu", {
  enumerable: false,
  get: function get() {
    return helix.dom.menu;
  }
});
Object.defineProperty(module.exports, "blockquote", {
  enumerable: false,
  get: function get() {
    return helix.dom.blockquote;
  }
});
Object.defineProperty(module.exports, "img", {
  enumerable: false,
  get: function get() {
    return helix.dom.img;
  }
});
Object.defineProperty(module.exports, "text", {
  enumerable: false,
  get: function get() {
    return helix.dom.text;
  }
});
Object.defineProperty(module.exports, "span", {
  enumerable: false,
  get: function get() {
    return helix.dom.span;
  }
});
Object.defineProperty(module.exports, "track", {
  enumerable: false,
  get: function get() {
    return helix.dom.track;
  }
});
Object.defineProperty(module.exports, "data", {
  enumerable: false,
  get: function get() {
    return helix.dom.data;
  }
});
Object.defineProperty(module.exports, "u", {
  enumerable: false,
  get: function get() {
    return helix.dom.u;
  }
});
Object.defineProperty(module.exports, "dl", {
  enumerable: false,
  get: function get() {
    return helix.dom.dl;
  }
});
Object.defineProperty(module.exports, "select", {
  enumerable: false,
  get: function get() {
    return helix.dom.select;
  }
});
Object.defineProperty(module.exports, "polygon", {
  enumerable: false,
  get: function get() {
    return helix.dom.polygon;
  }
});
Object.defineProperty(module.exports, "pattern", {
  enumerable: false,
  get: function get() {
    return helix.dom.pattern;
  }
});
Object.defineProperty(module.exports, "html", {
  enumerable: false,
  get: function get() {
    return helix.dom.html;
  }
});
Object.defineProperty(module.exports, "thead", {
  enumerable: false,
  get: function get() {
    return helix.dom.thead;
  }
});
Object.defineProperty(module.exports, "path", {
  enumerable: false,
  get: function get() {
    return helix.dom.path;
  }
});
Object.defineProperty(module.exports, "del", {
  enumerable: false,
  get: function get() {
    return helix.dom.del;
  }
});
Object.defineProperty(module.exports, "fieldset", {
  enumerable: false,
  get: function get() {
    return helix.dom.fieldset;
  }
});
Object.defineProperty(module.exports, "aside", {
  enumerable: false,
  get: function get() {
    return helix.dom.aside;
  }
});
Object.defineProperty(module.exports, "figure", {
  enumerable: false,
  get: function get() {
    return helix.dom.figure;
  }
});
Object.defineProperty(module.exports, "figcaption", {
  enumerable: false,
  get: function get() {
    return helix.dom.figcaption;
  }
});
Object.defineProperty(module.exports, "mask", {
  enumerable: false,
  get: function get() {
    return helix.dom.mask;
  }
});
Object.defineProperty(module.exports, "q", {
  enumerable: false,
  get: function get() {
    return helix.dom.q;
  }
});
Object.defineProperty(module.exports, "tags", {
  enumerable: false,
  get: function get() {
    return helix.dom.tags;
  }
});
Object.defineProperty(module.exports, "bdi", {
  enumerable: false,
  get: function get() {
    return helix.dom.bdi;
  }
});
Object.defineProperty(module.exports, "video", {
  enumerable: false,
  get: function get() {
    return helix.dom.video;
  }
});
Object.defineProperty(module.exports, "address", {
  enumerable: false,
  get: function get() {
    return helix.dom.address;
  }
});
Object.defineProperty(module.exports, "caption", {
  enumerable: false,
  get: function get() {
    return helix.dom.caption;
  }
});
Object.defineProperty(module.exports, "dd", {
  enumerable: false,
  get: function get() {
    return helix.dom.dd;
  }
});
Object.defineProperty(module.exports, "rp", {
  enumerable: false,
  get: function get() {
    return helix.dom.rp;
  }
});
Object.defineProperty(module.exports, "hr", {
  enumerable: false,
  get: function get() {
    return helix.dom.hr;
  }
});
Object.defineProperty(module.exports, "meta", {
  enumerable: false,
  get: function get() {
    return helix.dom.meta;
  }
});
Object.defineProperty(module.exports, "tbody", {
  enumerable: false,
  get: function get() {
    return helix.dom.tbody;
  }
});
Object.defineProperty(module.exports, "table", {
  enumerable: false,
  get: function get() {
    return helix.dom.table;
  }
});
Object.defineProperty(module.exports, "pre", {
  enumerable: false,
  get: function get() {
    return helix.dom.pre;
  }
});
Object.defineProperty(module.exports, "ul", {
  enumerable: false,
  get: function get() {
    return helix.dom.ul;
  }
});
Object.defineProperty(module.exports, "sup", {
  enumerable: false,
  get: function get() {
    return helix.dom.sup;
  }
});
Object.defineProperty(module.exports, "dfn", {
  enumerable: false,
  get: function get() {
    return helix.dom.dfn;
  }
});
Object.defineProperty(module.exports, "sub", {
  enumerable: false,
  get: function get() {
    return helix.dom.sub;
  }
});
Object.defineProperty(module.exports, "mark", {
  enumerable: false,
  get: function get() {
    return helix.dom.mark;
  }
});
Object.defineProperty(module.exports, "script", {
  enumerable: false,
  get: function get() {
    return helix.dom.script;
  }
});
Object.defineProperty(module.exports, "big", {
  enumerable: false,
  get: function get() {
    return helix.dom.big;
  }
});
Object.defineProperty(module.exports, "button", {
  enumerable: false,
  get: function get() {
    return helix.dom.button;
  }
});
Object.defineProperty(module.exports, "wbr", {
  enumerable: false,
  get: function get() {
    return helix.dom.wbr;
  }
});
Object.defineProperty(module.exports, "strong", {
  enumerable: false,
  get: function get() {
    return helix.dom.strong;
  }
});
Object.defineProperty(module.exports, "li", {
  enumerable: false,
  get: function get() {
    return helix.dom.li;
  }
});
Object.defineProperty(module.exports, "dt", {
  enumerable: false,
  get: function get() {
    return helix.dom.dt;
  }
});
Object.defineProperty(module.exports, "td", {
  enumerable: false,
  get: function get() {
    return helix.dom.td;
  }
});
Object.defineProperty(module.exports, "tr", {
  enumerable: false,
  get: function get() {
    return helix.dom.tr;
  }
});
Object.defineProperty(module.exports, "circle", {
  enumerable: false,
  get: function get() {
    return helix.dom.circle;
  }
});
Object.defineProperty(module.exports, "section", {
  enumerable: false,
  get: function get() {
    return helix.dom.section;
  }
});
Object.defineProperty(module.exports, "th", {
  enumerable: false,
  get: function get() {
    return helix.dom.th;
  }
});
Object.defineProperty(module.exports, "time", {
  enumerable: false,
  get: function get() {
    return helix.dom.time;
  }
});
Object.defineProperty(module.exports, "optgroup", {
  enumerable: false,
  get: function get() {
    return helix.dom.optgroup;
  }
});
Object.defineProperty(module.exports, "iframe", {
  enumerable: false,
  get: function get() {
    return helix.dom.iframe;
  }
});
Object.defineProperty(module.exports, "legend", {
  enumerable: false,
  get: function get() {
    return helix.dom.legend;
  }
});
Object.defineProperty(module.exports, "em", {
  enumerable: false,
  get: function get() {
    return helix.dom.em;
  }
});
Object.defineProperty(module.exports, "kbd", {
  enumerable: false,
  get: function get() {
    return helix.dom.kbd;
  }
});
Object.defineProperty(module.exports, "article", {
  enumerable: false,
  get: function get() {
    return helix.dom.article;
  }
});
Object.defineProperty(module.exports, "clipPath", {
  enumerable: false,
  get: function get() {
    return helix.dom.clipPath;
  }
});
Object.defineProperty(module.exports, "abbr", {
  enumerable: false,
  get: function get() {
    return helix.dom.abbr;
  }
});
Object.defineProperty(module.exports, "source", {
  enumerable: false,
  get: function get() {
    return helix.dom.source;
  }
});
Object.defineProperty(module.exports, "output", {
  enumerable: false,
  get: function get() {
    return helix.dom.output;
  }
});
Object.defineProperty(module.exports, "header", {
  enumerable: false,
  get: function get() {
    return helix.dom.header;
  }
});
Object.defineProperty(module.exports, "datalist", {
  enumerable: false,
  get: function get() {
    return helix.dom.datalist;
  }
});
Object.defineProperty(module.exports, "tfoot", {
  enumerable: false,
  get: function get() {
    return helix.dom.tfoot;
  }
});
Object.defineProperty(module.exports, "s", {
  enumerable: false,
  get: function get() {
    return helix.dom.s;
  }
});
Object.defineProperty(module.exports, "ins", {
  enumerable: false,
  get: function get() {
    return helix.dom.ins;
  }
});
Object.defineProperty(module.exports, "footer", {
  enumerable: false,
  get: function get() {
    return helix.dom.footer;
  }
});
Object.defineProperty(module.exports, "title", {
  enumerable: false,
  get: function get() {
    return helix.dom.title;
  }
});
Object.defineProperty(module.exports, "h5", {
  enumerable: false,
  get: function get() {
    return helix.dom.h5;
  }
});
Object.defineProperty(module.exports, "canvas", {
  enumerable: false,
  get: function get() {
    return helix.dom.canvas;
  }
});
Object.defineProperty(module.exports, "param", {
  enumerable: false,
  get: function get() {
    return helix.dom.param;
  }
});
Object.defineProperty(module.exports, "div", {
  enumerable: false,
  get: function get() {
    return helix.dom.div;
  }
});
Object.defineProperty(module.exports, "option", {
  enumerable: false,
  get: function get() {
    return helix.dom.option;
  }
});
Object.defineProperty(module.exports, "summary", {
  enumerable: false,
  get: function get() {
    return helix.dom.summary;
  }
});
Object.defineProperty(module.exports, "samp", {
  enumerable: false,
  get: function get() {
    return helix.dom.samp;
  }
});
Object.defineProperty(module.exports, "small", {
  enumerable: false,
  get: function get() {
    return helix.dom.small;
  }
});
Object.defineProperty(module.exports, "style", {
  enumerable: false,
  get: function get() {
    return helix.dom.style;
  }
});
Object.defineProperty(module.exports, "textarea", {
  enumerable: false,
  get: function get() {
    return helix.dom.textarea;
  }
});
Object.defineProperty(module.exports, "h4", {
  enumerable: false,
  get: function get() {
    return helix.dom.h4;
  }
});
Object.defineProperty(module.exports, "head", {
  enumerable: false,
  get: function get() {
    return helix.dom.head;
  }
});
Object.defineProperty(module.exports, "g", {
  enumerable: false,
  get: function get() {
    return helix.dom.g;
  }
});
Object.defineProperty(module.exports, "stop", {
  enumerable: false,
  get: function get() {
    return helix.dom.stop;
  }
});
Object.defineProperty(module.exports, "var$", {
  enumerable: false,
  get: function get() {
    return helix.dom.var$;
  }
});
Object.defineProperty(module.exports, "tspan", {
  enumerable: false,
  get: function get() {
    return helix.dom.tspan;
  }
});
Object.defineProperty(module.exports, "ol", {
  enumerable: false,
  get: function get() {
    return helix.dom.ol;
  }
});
Object.defineProperty(module.exports, "details", {
  enumerable: false,
  get: function get() {
    return helix.dom.details;
  }
});
Object.defineProperty(module.exports, "line", {
  enumerable: false,
  get: function get() {
    return helix.dom.line;
  }
});
Object.defineProperty(module.exports, "col", {
  enumerable: false,
  get: function get() {
    return helix.dom.col;
  }
});
Object.defineProperty(module.exports, "label", {
  enumerable: false,
  get: function get() {
    return helix.dom.label;
  }
});
Object.defineProperty(module.exports, "picture", {
  enumerable: false,
  get: function get() {
    return helix.dom.picture;
  }
});
Object.defineProperty(module.exports, "rt", {
  enumerable: false,
  get: function get() {
    return helix.dom.rt;
  }
});
Object.defineProperty(module.exports, "h6", {
  enumerable: false,
  get: function get() {
    return helix.dom.h6;
  }
});
Object.defineProperty(module.exports, "link", {
  enumerable: false,
  get: function get() {
    return helix.dom.link;
  }
});
Object.defineProperty(module.exports, "defs", {
  enumerable: false,
  get: function get() {
    return helix.dom.defs;
  }
});
Object.defineProperty(module.exports, "colgroup", {
  enumerable: false,
  get: function get() {
    return helix.dom.colgroup;
  }
});
Object.defineProperty(module.exports, "meter", {
  enumerable: false,
  get: function get() {
    return helix.dom.meter;
  }
});
Object.defineProperty(module.exports, "bdo", {
  enumerable: false,
  get: function get() {
    return helix.dom.bdo;
  }
});
Object.defineProperty(module.exports, "b", {
  enumerable: false,
  get: function get() {
    return helix.dom.b;
  }
});
Object.defineProperty(module.exports, "svg", {
  enumerable: false,
  get: function get() {
    return helix.dom.svg;
  }
});
Object.defineProperty(module.exports, "ellipse", {
  enumerable: false,
  get: function get() {
    return helix.dom.ellipse;
  }
});
Object.defineProperty(module.exports, "code", {
  enumerable: false,
  get: function get() {
    return helix.dom.code;
  }
});
Object.defineProperty(module.exports, "dialog", {
  enumerable: false,
  get: function get() {
    return helix.dom.dialog;
  }
});
Object.defineProperty(module.exports, "linearGradient", {
  enumerable: false,
  get: function get() {
    return helix.dom.linearGradient;
  }
});
Object.defineProperty(module.exports, "noscript", {
  enumerable: false,
  get: function get() {
    return helix.dom.noscript;
  }
});
Object.defineProperty(module.exports, "h2", {
  enumerable: false,
  get: function get() {
    return helix.dom.h2;
  }
});
Object.defineProperty(module.exports, "area", {
  enumerable: false,
  get: function get() {
    return helix.dom.area;
  }
});
Object.defineProperty(module.exports, "br", {
  enumerable: false,
  get: function get() {
    return helix.dom.br;
  }
});